import { FormGroup } from 'components/elements/Inputs/Input.css'
import NewButton from 'components/elements/NewButton'
import Stack from 'components/elements/Stack'
import { ChatType, UserChat } from 'interfaces/UserChat'
import { shareChatRoute } from 'lib/constants/routes'
import { copyTextToClipboard } from 'lib/features/coping'
import { useEffect, useState } from 'react'
import FeatureDialog from 'stories/elements/Modal/DialogWindow/FeatureDialog'
import { Body1, ButtonText } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled from 'styled-components'
import CopyIcon from 'assets/icons/webapp_copy.svg'

const ShareRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    input {
        width: 350px !important;
    }
    svg {
        fill: transparent;
    }
    align-items: center;
`

interface Props {
    open: boolean
    onClose: () => void
    chat: UserChat
}

const ChatInformationDialog = ({ open, onClose, chat }: Props) => {
    const [shareChatLink, setShareChatLink] = useState('')

    useEffect(() => {
        setShareChatLink(`${document.location.host}${shareChatRoute(chat.uuid, { referrer: 'share' })}`)
    }, [])

    const copyKnowLink = () => {
        copyTextToClipboard(shareChatLink, 'Link copied!')
    }

    return (
        <FeatureDialog
            open={open}
            onClose={onClose}
            ariaPrefix="chat-members"
            title={'Information about chat'}
            maxWidth={500}
            allowVerticalOverflow
        >
            <br />
            <Stack>
                <Body1 fontFamily="var(--font-inter)" fontWeight={400}>
                    {`Name: ${chat.name}`}
                </Body1>
                <Body1 fontFamily="var(--font-inter)" fontWeight={400}>
                    {`Description: ${chat.description ?? 'Not specified'}`}
                </Body1>
                {chat.chatType === ChatType.Group ? (
                    <>
                        <Body1 fontFamily="var(--font-inter)" fontWeight={500} color={theme.colors.deepSeaBlue}>
                            {`Share group chat`}
                        </Body1>
                        <ShareRow>
                            <FormGroup noMargin>
                                <label>
                                    <input defaultValue={shareChatLink} id="link" disabled />
                                </label>
                            </FormGroup>
                            <NewButton
                                height={60}
                                color={theme.colors.deepSeaBlue}
                                type="secondary"
                                borderRadius={theme.borderRadius.normal}
                                icon={<CopyIcon />}
                                onClick={copyKnowLink}
                            >
                                <ButtonText color={theme.colors.deepSeaBlue}>Copy</ButtonText>
                            </NewButton>
                        </ShareRow>
                    </>
                ) : null}
            </Stack>
        </FeatureDialog>
    )
}

export default ChatInformationDialog
